import WithLogoCol from './WithLogoCol'
export default WithLogoCol